export const REPORT_TYPE = Object.freeze({
    COMPONENT: 'COMPONENT',
    PL: 'PL',
    TREND: 'TREND',
    WBR: 'WBR',
    HCP: 'HCP-SPOT',
    BENCHMARK: 'BENCHMARK',
    THIRTEEN_MONTH_REPORT: '13-MONTH-REPORT',
    ASIN_METRICS_REPORT: 'ASIN-METRICS',
    BRIDGING_FACTORS: 'BRIDGING-FACTORS',
    FORECAST: 'FORECAST',
});


// WEBPACK FOOTER //
// ./src/constants/report_type.jsx